"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Buhin = void 0;
var Buhin = /** @class */ (function () {
    function Buhin() {
        // initialize
        // no operation
        this.hash = {};
    }
    // method
    Buhin.prototype.set = function (name, data) {
        this.hash[name] = data;
    };
    Buhin.prototype.search = function (name) {
        if (this.hash[name]) {
            return this.hash[name];
        }
        return ""; // no data
    };
    Buhin.prototype.push = function (name, data) {
        this.set(name, data);
    };
    return Buhin;
}());
exports.Buhin = Buhin;
